import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkPositionAuditImplEncoder } from "../../encoder/BenchmarkPositionAuditImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkPositionAudit } from "../BenchmarkPositionAudit";

export class BenchmarkPositionAuditImpl
  extends ConcreteEncodable
  implements BenchmarkPositionAudit
{
  public static enType: string = "com.bcdfx.model.audit.BenchmarkPositionAuditImpl";

  /*FID=1*/
  public auditId: CubiqTS.Long | null = null;
  /*FID=2*/
  public userId: CubiqTS.Long | null = null;
  /*FID=3*/
  public bmTimeCode: CubiqTS.BMTimeCode | null = null;
  /*FID=4*/
  public orderAction: string;
  /*FID=5*/
  public orderState: CubiqTS.OrderState;
  /*FID=6*/
  public actionTime: CubiqTS.Long | null = null;
  /*FID=7*/
  public comments: string;
  /*FID=8*/
  public userName: string;
  /*FID=9*/
  public userCd: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkPositionAuditImplEncoder.Instance;
    this.setEncodableType(BenchmarkPositionAuditImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkPositionAuditImpl[" +
      "auditId=" +
      this.auditId +
      "userId=" +
      this.userId +
      "bmTimeCode=" +
      this.bmTimeCode +
      "orderAction=" +
      this.orderAction +
      "orderState=" +
      this.orderState +
      "actionTime=" +
      this.actionTime +
      "comments=" +
      this.comments +
      "userName=" +
      this.userName +
      "userCd=" +
      this.userCd +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
